export const getMarketingBars = state => state.marketingBars.data;
export const getMarketingBarsHidden = state => state.marketingBars.hidden;
